
/* gt-mobile-menu-fix */
(function(){
  function openMobileNav(){
    document.body.classList.add('navbar-collapse-show','navbar-open');
    var nav=document.getElementById('navbarNav');
    if(nav){ nav.classList.add('show'); }
  }
  function closeMobileNav(){
    document.body.classList.remove('navbar-collapse-show','navbar-open');
    var nav=document.getElementById('navbarNav');
    if(nav){ nav.classList.remove('show'); }
  }
  document.addEventListener('click', function(e){
    var t=e.target;
    if(!t) return;
    if(t.closest && t.closest('.navbar-toggler.toggle-mobile')){
      // let bootstrap also run; ensure body class for theme CSS
      setTimeout(openMobileNav, 0);
      return;
    }
    if(t.closest && t.closest('.back-wrapper.menu-close, .menu-overlay')){
      closeMobileNav();
      return;
    }
  }, true);
  document.addEventListener('DOMContentLoaded', function(){
    var nav=document.getElementById('navbarNav');
    if(!nav) return;
    nav.addEventListener('show.bs.collapse', openMobileNav);
    nav.addEventListener('shown.bs.collapse', openMobileNav);
    nav.addEventListener('hide.bs.collapse', closeMobileNav);
    nav.addEventListener('hidden.bs.collapse', closeMobileNav);
  });
})();
